import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const deleteCrmAccountOperation = async (
  accountId: number,
  setDeletingId: (id: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setDeletingId(accountId);

    const res = await appApi.deleteCrmAccount(accountId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setDeletingId(null);
      return;
    }

    toast.success('הארגון נמחק בהצלחה');
    setDeletingId(null);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setDeletingId(null);
  }
};
